import { composeClassNames } from "@faedev/editor-utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { Badge, Button, Card } from "react-bootstrap";
import Preloader from "src/components/Preloader";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import getLink from "src/functions/getLink";
import validateAuthToken from "src/functions/validateAuthToken";
import Small_cancel from "src/icons/Small-cancel";
import { sBadge } from "src/styles/sBadge.module.scss";
import { sCartCard } from "src/styles/sCartCard.module.scss";
import { sCartCardBody } from "src/styles/sCartCardBody.module.scss";

type Props = {
  orderId?: number;
  itemId?: number;
  imgURL?: { url: string };
  title?: string;
  amountTotal?: number;
  type?: string;
  discount?: string | number;
  priceBasic?: string;
  price?: string;
  slug?: string;
  setShowItem?: (setShowItem: boolean) => void;
  isStream?: boolean;
};

const CartItem = (props: Props) => {
  const { locale: lang } = useRouter();
  var [loading, setLoading] = useState(false);
  let itemType = props.type && props.type === "lecture" ? "class" : "serie";

  return (
    <Card className={composeClassNames([sCartCard, "cart-item"])}>
      {typeof props.slug !== "undefined" && (
        <Link
          href={
            props.slug &&
            getLink(
              lang,
              props.isStream && props.isStream === true ? "stream" : itemType,
              props.slug,
              null
            )
          }
          passHref
          locale={false}
        >
          <Card.Link>
            <Card.Img
              src={
                props.imgURL !== undefined && props.imgURL !== null
                  ? props.imgURL.url
                  : ""
              }
              alt={props.title}
            />
          </Card.Link>
        </Link>
      )}
      <Card.Body className={composeClassNames([sCartCardBody, "cart-body"])}>
        {typeof props.slug !== "undefined" && props.title && (
          <Link
            href={
              props.slug &&
              getLink(
                lang,
                props.isStream && props.isStream === true ? "stream" : itemType,
                props.slug,
                null
              )
            }
            passHref
            locale={false}
          >
            <Card.Link>
              <Card.Title>{props.title}</Card.Title>
            </Card.Link>
          </Link>
        )}
        {typeof props.slug === "undefined" && props.title && (
          <Card.Title>{props.title}</Card.Title>
        )}
        {props.amountTotal > 0 && <Card.Text>{props.amountTotal}</Card.Text>}
        <Card.Text>
          {props.type && (
            <Badge
              pill={true}
              variant={`secondary`}
              className={composeClassNames([
                sBadge,
                "badge-outline",
                "badge-program",
              ])}
            >
              {props.type === "lecture" && <Translate tKey={`Class`} />}
              {props.type === "program" && <Translate tKey={`Serie`} />}
              {props.type === "stream" && <Translate tKey={`Stream`} />}
            </Badge>
          )}
          {props.discount && (
            <Badge
              pill={true}
              variant={`secondary`}
              className={composeClassNames([sBadge, "badge-discount"])}
            >
              -{props.discount}%
            </Badge>
          )}
          <div className="card-prices">
            {props.priceBasic && (
              <span className="card-price card-price-basic">
                {props.priceBasic},-
              </span>
            )}
            <span className="card-price">{props.price},-</span>
          </div>
        </Card.Text>
        <Button
          variant={`link`}
          onClick={async function () {
            setLoading(true);
            return await (async function iife() {
              await (async function iife() {
                var result = await (() =>
                  fetch(
                    `${constants.Paths.apiUrl}/orders/${props.orderId}/${props.itemId}`,
                    {
                      method: "DELETE",
                      headers: validateAuthToken(getCookieByName(`auth-token`)),
                    }
                  )
                    .then((res) => {
                      if (res.ok) {
                        return res.json();
                      } else {
                        throw new Error("API Error");
                      }
                    })
                    .then(() => {
                      props.setShowItem(false);
                    }))();
                return result;
              })();
            })();
          }}
          size={`sm`}
          className={`btn-delete`}
        >
          {loading ? <Preloader size="sm" /> : <Small_cancel />}
        </Button>
      </Card.Body>
    </Card>
  );
};

export default CartItem;
